import React, { useState, MouseEvent } from 'react';
import { IconButton, Menu, MenuItem, Tooltip, Box, styled } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../context/AuthProvider';
import { useLanguage } from '../../../../context/LanguageContext';

const StyledMenuItem = styled(MenuItem)({
  padding: '10px 16px',
  minWidth: 160,
  '&:hover': {
    backgroundColor: 'rgba(85, 110, 230, 0.08)',
  },
});

const UserMenu: React.FC = () => {
  const { logout } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    logout();
  };

  const handleSettings = () => {
    handleClose();
    navigate('/parametres');
  };

  return (
    <>
      <Tooltip title={t('header.settings')}>
        <IconButton
          onClick={handleClick}
          sx={{
            color: '#495057',
            backgroundColor: open ? 'rgba(85, 110, 230, 0.1)' : 'transparent',
            transition: 'all 0.2s ease',
            '&:hover': {
              backgroundColor: 'rgba(85, 110, 230, 0.1)',
            },
          }}
        >
          <i className="bx bx-cog" style={{ fontSize: 22 }} />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            mt: 1,
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            borderRadius: 2,
          },
        }}
      >
        <StyledMenuItem onClick={handleSettings}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <i className="bx bx-cog" style={{ fontSize: 18, color: '#495057' }} />
            <span>{t('pages.settings.title')}</span>
          </Box>
        </StyledMenuItem>
        <StyledMenuItem onClick={handleLogout}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <i className="bx bx-log-out" style={{ fontSize: 18, color: '#495057' }} />
            <span>{t('header.logout')}</span>
          </Box>
        </StyledMenuItem>
      </Menu>
    </>
  );
};

export default UserMenu;
